import { extractList } from "../../../../../core/service/BusinessLogicService"
import { loc } from "../../../../../core/utils"
import Select from "../../../../../form/Select"
import React from "react"

function extractionAndFilterSelectedValue(array, filterByCondition) {
  const list = extractList(array)
  const filter = list.filter((element) => element.value === filterByCondition)
  return filter
}

export default function SelectIdentificationClientPage(props) {
  const { tunnelData, values, country } = props
  const { clientPageConfiguration } = tunnelData
  const languageTag = tunnelData?.data?.order?.orderLanguageTag || ""
  let { identity, leaderIdentity } = clientPageConfiguration

  identity = identity ? identity : leaderIdentity

  return (
    <>
      <Select
        hidden={!identity?.includes("birthCountry")}
        name="identity.birthCountry"
        label={loc`Country of birth`}
        placeholder={loc`Select...`}
        url={
          values?.identity?.birthCountry?.value &&
          `${tunnelData.apiUrl}middle-business-service/api/v2/repository/countries/codes/${country}?languageTag=${encodeURIComponent(
            languageTag
          )}`
        }
        token={tunnelData.access_token}
        disabled={!tunnelData.simplifiedJourneyInputConfiguration.identity.birthCountry.editable}
        extract={(items) => extractionAndFilterSelectedValue(items, values?.identity?.birthCountry?.value)}
      />
      <Select
        hidden={!identity?.includes("birthDepartment")}
        name="identity.birthDepartment"
        placeholder={loc`Select...`}
        label={loc`Department of birth`}
        url={
          values?.identity?.birthDepartment?.value &&
          `${
            tunnelData.apiUrl
          }middle-business-service/api/v2/repository/departments/codes?journeyCountryCode=${country}&countryCode=${
            values?.identity?.birthCountry?.value || values?.identity?.birthCountry
          }`
        }
        token={tunnelData.access_token}
        disabled={!tunnelData.simplifiedJourneyInputConfiguration.identity.birthDepartment.editable}
        extract={(items) => extractionAndFilterSelectedValue(items, values?.identity?.birthDepartment?.value)}
      />
      <Select
        hidden={!identity?.includes("birthCity")}
        name="identity.birthCity"
        label={loc`City of birth`}
        placeholder={loc`Select...`}
        url={
          values.identity?.birthCity?.value &&
          `${tunnelData.apiUrl}middle-business-service/api/v2/repository/cities/?departmentId=${
            values?.identity?.birthDepartment?.value
          }&languageTag=${encodeURIComponent(languageTag)}`
        }
        token={tunnelData.access_token}
        enableMatchLabel={true}
        disabled={!tunnelData.simplifiedJourneyInputConfiguration.identity.birthCity.editable}
        extract={(items) => extractionAndFilterSelectedValue(items, values?.identity?.birthCity?.value)}
      />
    </>
  )
}
